module.exports = __webpack_public_path__ + "img/paperplane_fall2.991e888e.png";